import './App.css';

import { Fragment, useState, useEffect } from 'react';
import { Disclosure, Dialog, Transition } from '@headlessui/react';

const assets = {
  screen_welcome: {
    default_image: 'images/screen_welcome.png',
    title: 'Welcome',
    description: '',
    versions: [],
  },
  language_ask: {
    default_image: 'images/screen_languageask.png',
    title: 'Language Ask',
    description: '',
    versions: [
      {
        image: 'images/screen_languageask.png',
        title: 'Language Ask',
      },
      {
        image: 'images/screen_languageask_01.png',
        title: 'Language Ask (Part 2)',
      },
    ],
  },
  check_registration: {
    default_image: 'images/screen_checkregistration.png',
    title: 'Check Registration',
    description: '',
    versions: [
      {
        image: 'images/screen_checkregistration.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_checkregistration_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_checkregistration_error.png',
        title: 'Error Input',
      },
    ],
  },
  registration_status_not_registered: {
    default_image: 'images/screen_checkregistration_not_registered.png',
    title: 'Registration Status',
    description: '',
    versions: [],
  },
  registration_status_registered: {
    default_image: 'images/screen_checkregistration_registered.png',
    title: 'Registration Status',
    description: '',
    versions: [],
  },
  new_registration: {
    default_image: 'images/screen_newregistration.png',
    title: 'New Registration',
    description: '',
    versions: [
      {
        image: 'images/screen_newregistration.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_newregistration_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_newregistration_error.png',
        title: 'Error Input',
      },
    ]
  },
  disclaimer: {
    default_image: 'images/screen_disclaimer.png',
    title: 'Disclaimer',
    description: '',
    versions: [],
  },
  qualifications: {
    default_image: 'images/screen_qualifications.png',
    title: 'Qualifications',
    description: '',
    versions: [
      {
        image: 'images/screen_qualifications.png',
        title: 'Qualifications',
      },
      {
        image: 'images/screen_qualifications_01.png',
        title: 'Qualifications (Part 2)',
      },],
  },
  qualifications_valid: {
    default_image: 'images/screen_qualifications_input.png',
    title: 'Qualifications (Valid)',
    description: '',
    versions: [
      {
        image: 'images/screen_qualifications_input.png',
        title: 'Valid Qualifications',
      },
      {
        image: 'images/screen_qualifications_input_01.png',
        title: 'Valid Qualifications (Part 2)',
      },
    ],
  },
  id_ask: {
    default_image: 'images/screen_idask.png',
    title: 'ID Ask',
    description: '',
    versions: [],
  },
  id_ask_input01: {
    default_image: 'images/screen_idask_input_01.png',
    title: 'ID Ask',
    description: '',
    versions: [],
  },
  id_ask_input02: {
    default_image: 'images/screen_idask_input_02.png',
    title: 'ID Ask',
    description: '',
    versions: [],
  },
  id_ask_input03: {
    default_image: 'images/screen_idask_input_03.png',
    title: 'ID Ask',
    description: '',
    versions: [],
  },
  input_id: {
    default_image: 'images/screen_inputid.png',
    title: 'ID Info',
    description: '',
    versions: [
      {
        image: 'images/screen_inputid.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_inputid_01.png',
        title: 'Empty Form (Part 2)',
      },
      {
        image: 'images/screen_inputid_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_inputid_input_01.png',
        title: 'Form Input (Part 2)',
      },
      {
        image: 'images/screen_inputid_error.png',
        title: 'Error Input',
      },
      {
        image: 'images/screen_inputid_error_01.png',
        title: 'Error Input (Part 2)',
      },
    ]
  },
  ssn_ask: {
    default_image: 'images/screen_ssn.png',
    title: 'SSN',
    description: '',
    versions: [
      {
        image: 'images/screen_ssn.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_ssn_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_ssn_error.png',
        title: 'Error Input',
      },
    ],
  },
  ssn_info: {
    default_image: 'images/screen_ssninfo.png',
    title: 'Address Info',
    description: '',
    versions: [
      {
        image: 'images/screen_ssninfo.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_ssninfo_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_ssninfo_error.png',
        title: 'Error Input',
      },
    ]
  },
  mailing_ask: {
    default_image: 'images/screen_mailingask.png',
    title: 'Mailing Ask',
    description: '',
    versions: [
      {
        image: 'images/screen_mailingask.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_mailingask_error.png',
        title: 'Error Input',
      },
    ],
  },
  mailing_ask_yes: {
    default_image: 'images/screen_mailingask_yes.png',
    title: 'Mailing Ask (Yes)',
    description: '',
    versions: [],
  },
  mailing_ask_no: {
    default_image: 'images/screen_mailingask_no.png',
    title: 'Mailing Ask (No)',
    description: '',
    versions: [],
  },
  mailing_form: {
    default_image: 'images/screen_mailingform.png',
    title: 'Mailing Form',
    description: '',
    versions: [
      {
        image: 'images/screen_mailingform.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_mailingform_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_mailingform_error.png',
        title: 'Error Input',
      },
    ]
  },
  review: {
    default_image: 'images/screen_review.png',
    title: 'Review',
    description: '',
    versions: [
      {
        image: 'images/screen_review.png',
        title: 'Personal Info',
      },
      {
        image: 'images/screen_review_01.png',
        title: 'Residential Info',
      },
      {
        image: 'images/screen_review_02.png',
        title: 'License/SSN Info',
      },
    ],
  },
  signature_review: {
    default_image: 'images/screen_signaturereview.png',
    title: 'Signature Review',
    description: '',
    versions: [
      {
        image: 'images/screen_signaturereview.png',
        title: 'Initial View',
      },
      {
        image: 'images/dialog_signature.png',
        title: 'Signature Dialog',
      },
      {
        image: 'images/dialog_signature_input.png',
        title: 'Signature Signed',
      },
      {
        image: 'images/screen_signaturereview_complete.png',
        title: 'Signature Review',
      },
    ],
  },
  registration_complete: {
    default_image: 'images/screen_regcomplete.png',
    title: 'Registration Complete',
    description: '',
    versions: [
      {
        image: 'images/screen_regcomplete.png',
        title: 'Part 1',
      },
      {
        image: 'images/screen_regcomplete_01.png',
        title: 'Part 2',
      },],
  },

  not_eligible: {
    default_image: 'images/screen_noteligible.png',
    title: 'Not Eligible',
    description: '',
    versions: [],
  },
  optin_form: {
    default_image: 'images/screen_optin.png',
    title: 'Opt-In Form',
    description: '',
    versions: [
      {
        image: 'images/screen_optin.png',
        title: 'Empty Form',
      },
      {
        image: 'images/screen_optin_input.png',
        title: 'Form Input',
      },
      {
        image: 'images/screen_optin_error.png',
        title: 'Form Error',
      },
    ],
  },
  thankyou: {
    default_image: 'images/screen_thankyou.png',
    title: 'Thank You',
    description: '',
    versions: [],
  },
};

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function App() {
  const [open, setOpen] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState('not_registered');
  const [isEligibleDisclaimer, setIsEligibleDisclaimer] = useState(true);
  const [isQualificationsValid, setIsQualificationsValid] = useState(true);
  const [idInfo, setIDInfo] = useState('has_id');
  const [hasMailing, setHasMailing] = useState(false);
  const [hasNoSSN, setHasNoSSN] = useState(false);

  const [workflow, setWorkflow] = useState([]);
  const [registrationType, setRegistrationType] = useState(null);

  const updateWorkflow = () => {
    let _workflow = [
      assets.screen_welcome,
      assets.language_ask,
      assets.check_registration,
    ];

    if (registrationStatus === 'registered_no_update') {
      _workflow.push(...[
        assets.registration_status_registered,
        assets.optin_form,
        assets.thankyou,
      ]);

      setWorkflow(_workflow);
      setRegistrationType('On Roll');
      return;
    } else if (registrationStatus === 'registered_update') {
      _workflow.push(assets.registration_status_registered);
    } else {
      _workflow.push(assets.registration_status_not_registered);
    }

    _workflow.push(...[
      assets.new_registration,
      assets.disclaimer,
    ]);

    if (!isEligibleDisclaimer) {
      _workflow.push(assets.not_eligible);
      _workflow.push(assets.optin_form);
      _workflow.push(assets.thankyou);

      setWorkflow(_workflow);
      setRegistrationType('Not Eligible');
      return;
    }

    _workflow.push(...[
      assets.qualifications,
    ]);

    if (!isQualificationsValid) {
      _workflow.push(assets.not_eligible);
      _workflow.push(assets.optin_form);
      _workflow.push(assets.thankyou);

      setWorkflow(_workflow);
      setRegistrationType('Not Eligible');
      return;
    }

    _workflow.push(...[
      assets.qualifications_valid,
      assets.id_ask,
    ]);

    if (idInfo === 'has_id') {
      _workflow.push(...[
        assets.input_id,
      ]);
    } else if (idInfo === 'no_id') {
      _workflow.push(...[
        assets.id_ask_input01,
        assets.not_eligible,
        assets.optin_form,
        assets.thankyou,
      ]);

      setWorkflow(_workflow);
      setRegistrationType('Not Eligible');
      return;
    } else if (idInfo === 'has_ssn') {
      _workflow.push(...[
        assets.id_ask_input01,
        assets.ssn_ask,
      ]);

      if (hasNoSSN) {
        _workflow.push(...[
          assets.not_eligible,
          assets.optin_form,
          assets.thankyou,
        ]);
  
        setWorkflow(_workflow);
        setRegistrationType('Not Eligible');
        return;
      }

      _workflow.push(...[
        assets.ssn_info,
      ]);
    } else if (idInfo === 'no_id_ssn') {
      _workflow.push(...[
        assets.id_ask_input03,
        assets.ssn_info,
      ]);
    }


    _workflow.push(...[
      assets.mailing_ask,
      ...(hasMailing ? [assets.mailing_ask_no] : [assets.mailing_ask_yes]),
      ...(hasMailing ? [assets.mailing_form] : []),
      assets.review,
      assets.signature_review,

      assets.registration_complete,
    ]);

    setRegistrationType('Online Registration');


    setWorkflow(_workflow);
  };

  useEffect(() => {
    updateWorkflow();
  }, [registrationStatus, isEligibleDisclaimer, isQualificationsValid, idInfo, hasNoSSN, hasMailing]);

  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="border-b border-gray-200 bg-primary">
          {({ open }) => (
            <>
              <div className="px-4 mx-auto text-black max-w-7xl sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                  <div className="flex grow">
                    <div className="flex items-center grow">
                      <h2 className="font-bold">Register MI Vote Workflow</h2>
                    </div>
                    <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                      <a
                        key="settings"
                        href="javascript: void(0);"
                        onClick={() => setOpen(true)}
                        className={classNames('border-transparent text-black inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium')}
                      >
                        Settings
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Disclosure>

        <div className="py-10">
          <header>
            <div className="pb-4 mx-auto max-w-7xl">
              <h1 className="text-3xl font-bold leading-tight text-gray-900">Current Workflow</h1>
            </div>
          </header>
          <main>
            <div className="flex items-start content-start mx-auto space-x-8 overflow-x-auto bg-gray-200 max-w-7xl sm:px-6 lg:px-8">
              {workflow.map((item, index) => {
                return (
                  <div className="flex-shrink-0 my-4 overflow-hidden bg-white shadow sm:rounded-lg w-96">
                    <div className="px-4 py-5 sm:px-6 bg-primary">
                      <h3 className="text-lg font-medium leading-6 text-black">{item.title}</h3>
                      <p className="max-w-2xl mt-1 text-sm text-black">{item.description}</p>
                    </div>
                    <div className="border-t border-gray-200">
                      <img id={'workflow_image_'+index} src={item.default_image} />
                    </div>
                    {item.versions.length > 0 && (
                      <div className="px-4 py-5 sm:px-6">
                        <ul role="list" className="divide-y divide-gray-300">
                        {item.versions.map((version) => {
                          return (<li className="px-2 py-2"><a href="javascript:void(0);" onClick={() => {
                            document.getElementById('workflow_image_'+index).src = version.image;
                          }}>{version.title}</a></li>);
                        })}
                        </ul>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="mx-auto mt-4 max-w-7xl">
              <p>Total Steps: {workflow.length}</p>
              <p>Registration Type: {registrationType}</p>
            </div>
          </main>
        </div>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="fixed inset-y-0 right-0 flex max-w-full pl-10 pointer-events-none sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="w-screen max-w-2xl pointer-events-auto">
                    <div className="flex flex-col h-full pb-6 overflow-y-scroll bg-white shadow-xl">
                      <div className="px-4 py-6 bg-secondary sm:px-6">
                        <div className="flex items-center justify-between">
                          <h2 className="text-lg font-medium font-bold text-black" id="slide-over-title">Workflow Settings</h2>
                          <div className="flex items-center ml-3 h-7">
                            <button type="button" onClick={() => setOpen(false)} className="text-indigo-200 rounded-md bg-secondary hover:text-white focus:outline-none focus:ring-2 focus:ring-white">
                              <span className="sr-only">Close panel</span>
                              <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="mt-1">
                          <p className="pr-8 text-sm font-bold text-black">Use the settings below to update the application workflow process as the registrant will see it.</p>
                        </div>
                      </div>
                      <div className="relative flex-1 px-4 mt-2 sm:px-6">
                        {/* Replace with your content */}
                        <div className="absolute inset-0 px-4 sm:px-6">

                          <div className="pt-2 pb-10">
                            <fieldset className="mt-8">
                              <legend className="text-base font-medium text-gray-900 contents">Registration Status</legend>
                              <p className="text-sm text-gray-500">Status of the user's registration after checking state results.</p>
                              <div className="mt-4 space-y-4">
                                <div className="flex items-center">
                                  <input
                                    id="registration_status_not_registered"
                                    name="registration_status"
                                    type="radio"
                                    className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                    checked={(registrationStatus === 'not_registered' ? true : false)}
                                    onChange={() => setRegistrationStatus('not_registered')}
                                  />
                                  <label htmlFor="registration_status_not_registered" className="block ml-3 text-sm font-medium text-gray-700">
                                    Not Registered
                                  </label>
                                </div>
                                <div className="flex items-center">
                                  <input
                                    id="registration_status_registered_update"
                                    name="registration_status"
                                    type="radio"
                                    className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                    checked={(registrationStatus === 'registered_update' ? true : false)}
                                    onChange={() => setRegistrationStatus('registered_update')}
                                  />
                                  <label htmlFor="registration_status_registered_update" className="block ml-3 text-sm font-medium text-gray-700">
                                    Registered (Making Changes)
                                  </label>
                                </div>
                                <div className="flex items-center">
                                  <input
                                    id="registration_status_registered_no_update"
                                    name="registration_status"
                                    type="radio"
                                    className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                    checked={(registrationStatus === 'registered_no_update' ? true : false)}
                                    onChange={() => setRegistrationStatus('registered_no_update')}
                                  />
                                  <label htmlFor="registration_status_registered_no_update" className="block ml-3 text-sm font-medium text-gray-700">
                                    Registered (No Changes)
                                  </label>
                                </div>
                              </div>
                            </fieldset>
                            <fieldset className="mt-8">
                              <legend className="text-base font-medium text-gray-900 contents">Eligibility Questions</legend>
                              <p className="text-sm text-gray-500">Checks to verify if the registrant is eligible to register.</p>
                              <div className="mt-4 space-y-4">
                              <div className="flex items-center">
                                  <input
                                    id="is_eligible_disclaimer"
                                    name="is_eligible_disclaimer"
                                    type="checkbox"
                                    className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                    checked={isEligibleDisclaimer}
                                    onChange={() => setIsEligibleDisclaimer(!isEligibleDisclaimer)}
                                  />
                                  <label htmlFor="is_eligible_disclaimer" className="block ml-3 text-sm font-medium text-gray-700">
                                    Confirms Disclaimer?
                                  </label>
                                </div>
                                <div className="flex items-center">
                                  <input
                                    id="is_qualifications_valid"
                                    name="is_qualifications_valid"
                                    type="checkbox"
                                    className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                    checked={isQualificationsValid}
                                    onChange={() => setIsQualificationsValid(!isQualificationsValid)}
                                  />
                                  <label htmlFor="is_qualifications_valid" className="block ml-3 text-sm font-medium text-gray-700">
                                    Is Qualified to Register?
                                  </label>
                                </div>
                              </div>
                            </fieldset>

                            {isEligibleDisclaimer && isQualificationsValid && (
                              <fieldset className="mt-8">
                                <legend className="text-base font-medium text-gray-900 contents">ID Information</legend>
                                <p className="text-sm text-gray-500">What type of ID information the registrant has available.</p>
                                <div className="mt-4 space-y-4">
                                  <div className="flex items-center">
                                    <input
                                      id="idinfo-hasid"
                                      name="idinfo"
                                      type="radio"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={(idInfo === 'has_id' ? true : false)}
                                      onChange={() => setIDInfo('has_id')}
                                    />
                                    <label htmlFor="idinfo-hasid" className="block ml-3 text-sm font-medium text-gray-700">
                                      MI Driver's License or State ID number on person
                                    </label>
                                  </div>
                                  <div className="flex items-center">
                                    <input
                                      id="idinfo-noid"
                                      name="idinfo"
                                      type="radio"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={(idInfo === 'no_id' ? true : false)}
                                      onChange={() => setIDInfo('no_id')}
                                    />
                                    <label htmlFor="idinfo-noid" className="block ml-3 text-sm font-medium text-gray-700">
                                      MI Driver's License or State ID number not on person
                                    </label>
                                  </div>
                                  <div className="flex items-center">
                                    <input
                                      id="idinfo-hasssn"
                                      name="idinfo"
                                      type="radio"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={(idInfo === 'has_ssn' ? true : false)}
                                      onChange={() => setIDInfo('has_ssn')}
                                    />
                                    <label htmlFor="idinfo-hasssn" className="block ml-3 text-sm font-medium text-gray-700">
                                      Social Security Number
                                    </label>
                                  </div>
                                  <div className="flex items-center">
                                    <input
                                      id="idinfo-noidssn"
                                      name="idinfo"
                                      type="radio"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={(idInfo === 'no_id_ssn' ? true : false)}
                                      onChange={() => setIDInfo('no_id_ssn')}
                                    />
                                    <label htmlFor="idinfo-noidssn" className="block ml-3 text-sm font-medium text-gray-700">
                                      No MI Driver's License, State ID number, or SSN
                                    </label>
                                  </div>
                                </div>
                              </fieldset>
                            )}

                            {(idInfo === 'has_ssn') && (
                              <fieldset className="mt-8">
                                <legend className="text-base font-medium text-gray-900 contents">SSN Info Not Available?</legend>
                                <p className="text-sm text-gray-500">Option for individuals that do not know SSN.</p>
                                <div className="mt-4 space-y-4">
                                  <div className="flex items-center">
                                    <input
                                      id="has_no_ssn"
                                      name="has_no_ssn"
                                      type="checkbox"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={hasNoSSN}
                                      onChange={() => setHasNoSSN(!hasNoSSN)}
                                    />
                                    <label htmlFor="has_no_ssn" className="block ml-3 text-sm font-medium text-gray-700">
                                      SSN Info Not Available
                                    </label>
                                  </div>
                                </div>
                              </fieldset>
                            )}

                            {(isEligibleDisclaimer && isQualificationsValid) && (
                              <fieldset className="mt-8">
                                <legend className="text-base font-medium text-gray-900 contents">Has Mailing Address?</legend>
                                <p className="text-sm text-gray-500">Checks if the registrant has a separate mailing address.</p>
                                <div className="mt-4 space-y-4">
                                  <div className="flex items-center">
                                    <input
                                      id="has_mailing"
                                      name="has_mailing"
                                      type="checkbox"
                                      className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                                      checked={hasMailing}
                                      onChange={() => setHasMailing(!hasMailing)}
                                    />
                                    <label htmlFor="has_mailing" className="block ml-3 text-sm font-medium text-gray-700">
                                      Has Separate Mailing Address
                                    </label>
                                  </div>
                                </div>
                              </fieldset>
                            )}
                            </div>
                        </div>
                        {/* /End replace */}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default App;
